import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

import { ref, watch } from "vue";
import BetterScroll from "better-scroll";
import { onMounted, onUnmounted } from "vue";
import AdvertPanelSection from "./AdvertPanelSection.vue";
import { AdvertisementList } from "@/data/index.type";
import { SliderTrigger } from "@/tools";
interface AdvertPanelContentProps {
  height: number;
  data: AdvertisementList;
  active: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertPanelContent',
  props: {
    height: null,
    data: null,
    active: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (event: "change", key: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  height: number;
  data: AdvertisementList;
  active: string;
}

const delayActive = ref<string>();
const scrollContainerRef = ref<HTMLDivElement>();
const scrollContentRef = ref<HTMLDivElement>();
let scroll: BetterScroll | undefined;
let sliderTrigger: SliderTrigger | undefined;



watch(
  () => props.active,
  () => {
    if (props.active === "") {
      scroll?.scrollTo(0, scroll.maxScrollY, 1000);
    }
    const element = scrollContainerRef.value!.querySelector(`[data-key="${props.active}"]`) as HTMLElement | null;
    if (element == null) return;
    scroll?.scrollToElement(element, 1000, 0, 0);
  }
);



onMounted(() => {
  delayActive.value = props.active;
  scroll = new BetterScroll(scrollContainerRef.value!, {
    mouseWheel: true,
    disableTouch: false,
    disableMouse: true,
  });

  scroll.on("mousewheelMove", (position: { y: number }) => {
    sliderTrigger?.refresh(Math.abs(position.y));
  });
  scroll.on("scrollEnd", () => {
    if (sliderTrigger?.isKey(props.active)) {
      delayActive.value = props.active;
    }
  });

  const lastChild = scrollContentRef.value!.lastElementChild as HTMLElement | null;
  if (lastChild !== null)
    scrollContentRef.value!.style.height = lastChild.offsetTop + Math.max(props.height, lastChild.offsetHeight) + "px";
  scroll?.refresh();
  sliderTrigger = new SliderTrigger(scrollContentRef.value!);
  sliderTrigger.onChange = function (key: string) {
    emit("change", key);
  };
});
onUnmounted(() => {
  scroll?.destroy();
  scroll = undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "scrollContainerRef",
    ref: scrollContainerRef,
    style: _normalizeStyle({ height: __props.height + 'px' }),
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content),
      ref_key: "scrollContentRef",
      ref: scrollContentRef
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, key) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
          (item.length > 0)
            ? (_openBlock(), _createBlock(AdvertPanelSection, {
                key: 0,
                title: key,
                data: item,
                "is-active": key === delayActive.value
              }, null, 8, ["title", "data", "is-active"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ], 2)
  ], 6))
}
}

})